import { render, staticRenderFns } from "./feature-type.vue?vue&type=template&id=d8a60592&scoped=true"
import script from "./feature-type.vue?vue&type=script&lang=js"
export * from "./feature-type.vue?vue&type=script&lang=js"
import style0 from "./feature-type.vue?vue&type=style&index=0&id=d8a60592&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a60592",
  null
  
)

export default component.exports